import React, { useState } from "react";

import { useAuth } from "../../hooks/pages/useAuth";

import { usePendingProperties } from "../../hooks/admin/notApproved/usePendingProperties";

import PendingPropertyFilters from "../../components/admin/notapproved/PendingPropertyFilters";
import PendingPropertyTable from "../../components/admin/notapproved/PendingPropertyTable";
import PendingPropertyPagination from "../../components/admin/notapproved/PendingPropertyPagination";
import PropertyDetailModal from "../../components/admin/notapproved/PropertyDetailModal";

const ManageNotApproved = () => {
    const { user } = useAuth();

    const {
        properties,
        loading,
        error,
        page,
        totalPages,
        filters,
        updatingStatus,

        setPage,
        handleFilterChange,

        approveProperty,
        rejectProperty,
    } = usePendingProperties();

    const [selectedProperty, setSelectedProperty] =
        useState(null);

    return (
        <div className="p-6">
            <h1 className="text-2xl font-bold mb-4">
                Bất động sản chưa phê duyệt
            </h1>

            <PendingPropertyFilters
                filters={filters}
                onChange={handleFilterChange}
            />

            {loading && <p>Đang tải dữ liệu...</p>}

            {error && (
                <p className="text-red-500">{error}</p>
            )}

            {!loading && !error && (
                <>
                    <PendingPropertyTable
                        properties={properties}
                        updatingStatus={updatingStatus}
                        isAdmin={user?.role === "admin"}
                        onView={setSelectedProperty}
                        onApprove={approveProperty}
                        onReject={rejectProperty}
                    />

                    <PendingPropertyPagination
                        page={page}
                        totalPages={totalPages}
                        onPageChange={setPage}
                    />

                    <PropertyDetailModal
                        property={selectedProperty}
                        onClose={() =>
                            setSelectedProperty(null)
                        }
                    />
                </>
            )}
        </div>
    );
};

export default ManageNotApproved;